export const SCRUB_REPLACEMENT = '********';

export const SCRUB_FIELDS = [
  'cardNumber',
  'cvv',
  'number',
  'cardSecurityCode',
  'card_id',
  'cardCvv',
  'card_token',
  'cardToken',
];

export const scrubValue = (obj: any) => {
  if (obj === null || obj === undefined) return obj;

  if (Array.isArray(obj)) {
    return obj.map(scrubValue);
  }

  if (typeof obj === 'string') {
    try {
      const parsed = JSON.parse(obj);
      return scrubValue(parsed);
    } catch {
      return obj;
    }
  }

  if (typeof obj === 'object') {
    const scrubbed = {};
    for (const key in obj) {
      if (SCRUB_FIELDS.includes(key)) {
        scrubbed[key] = SCRUB_REPLACEMENT;
      } else {
        scrubbed[key] = scrubValue(obj[key]);
      }
    }
    return scrubbed;
  }

  return obj;
};
